import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import classNames from "classnames";
import { getSkuSubcategories } from "../../../services/sku";
import { SKUS_QUERY_STRING } from "../../../constants/skus";
import Loading from "../../UI/Loading/Loading";
import EmptyContent from "../../UI/EmptyContent/EmptyContent";
import classes from "./Subcategories.module.css";

const Subcategories = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const categoryId = Number(searchParams.get(SKUS_QUERY_STRING.CATEGORY_ID));
  const [isSubCategoriesLoading, setIsSubCategoriesLoading] = useState(true);
  const [subcategories, setSubcategories] = useState([]);
  const [subcategoriesLoadingError, setSubcategoriesLoadingError] =
    useState("");
  const subcategoryIdQueryString = Number(
    searchParams.get(SKUS_QUERY_STRING.SUB_CATEGORY_ID)
  );

  const subcategorySelectedHandler = (subcategoryId) => {
    if (!subcategoryId && searchParams.has(SKUS_QUERY_STRING.SUB_CATEGORY_ID)) {
      searchParams.delete(SKUS_QUERY_STRING.SUB_CATEGORY_ID);
      setSearchParams(searchParams);
    } else if (subcategoryId) {
      searchParams.set(SKUS_QUERY_STRING.SUB_CATEGORY_ID, subcategoryId);
      setSearchParams(searchParams);
    }
  };

  useEffect(() => {
    const fetchSubcategories = async () => {
      try {
        setIsSubCategoriesLoading(true);
        setSubcategoriesLoadingError("");
        const response = await getSkuSubcategories(categoryId);
        const {
          data: { skuSubCategoriesList },
        } = response;
        setSubcategories([
          { id: null, subCategoryName: "الكل" },
          ...skuSubCategoriesList,
        ]);
      } catch (err) {
        setSubcategoriesLoadingError("لا يوجد فئات لعرضها !");
      } finally {
        setIsSubCategoriesLoading(false);
      }
    };

    if (categoryId) {
      fetchSubcategories();
    }
  }, [categoryId]);

  if (!categoryId) return;

  return (
    <aside className={classes["subcategories"]}>
      <h2 className={classes["subcategories__header"]}>فئات القسم</h2>
      {isSubCategoriesLoading ? (
        <Loading className={classes["subcategories__loading"]} />
      ) : subcategoriesLoadingError ? (
        <EmptyContent
          message={subcategoriesLoadingError}
          className={classes["subcategories__empty"]}
        />
      ) : (
        <ul className={classes["subcategories__list"]}>
          {subcategories.map((subcategory, index) => (
            <li
              key={index}
              className={classNames(classes["subcategories__list-item"], {
                [classes["subcategories__list-item--active"]]:
                  !subcategoryIdQueryString && !subcategory.id
                    ? true
                    : subcategoryIdQueryString === subcategory.id
                    ? true
                    : false,
              })}
              role="button"
              onClick={() => subcategorySelectedHandler(subcategory.id)}
            >
              {subcategory.subCategoryName}
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
};

export default Subcategories;
